import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';
import { getGICTypeName } from '@ratehub/inv-common';

import ProductFeatureList from './ProductFeatureList';


function ProductListGICsDetails({ term, type, minimumInvestment, ...otherProps }) {
    const intl = useIntl();
    const items = createItems({ term, type, minimumInvestment, intl });

    return (
        <MyProductFeatureList
            items={items}
            {...otherProps}
        />
    );
}

ProductListGICsDetails.propTypes = {
    term: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    minimumInvestment: PropTypes.number.isRequired,
};

const MyProductFeatureList = styled(ProductFeatureList)`
    max-width: 28em;
`;

function createItems({ term, type, minimumInvestment, intl }) {
    return [
        {
            term: (
                <FormattedMessage
                    id="web-components.gics.term"
                    defaultMessage="Term"
                />
            ),
            definition: (
                <FormattedMessage
                    id="web-components.gics.term-value"
                    /* note that term formatting breaks down if not 3, 6, or 9 months or an uneven number of years */
                    defaultMessage={`<b>{term,
select,
    1 {30 Days}
    3 {90 Days}
    4 {120 Days}
    6 {180 Days}
    9 {270 Days}
    other {{termInYears, plural, one {# Year} other {# Years}}}
}</b>`}
                    values={{
                        term: term,
                        termInYears: term / 12,
                        ...DefaultIntlFormatValues,
                    }}
                />
            ),
        },
        {
            term: (
                <FormattedMessage
                    id="web-components.gics.type"
                    defaultMessage="Type"
                />
            ),
            definition: (
                <FormattedMessage
                    id="web-components.gics.type-value"
                    defaultMessage="<b>{type}</b>"
                    values={{
                        type: getGICTypeName(type, intl),
                        ...DefaultIntlFormatValues,
                    }}
                />
            ),
        },
        {
            term: (
                <FormattedMessage
                    id="web-components.gics.minimum-investment"
                    defaultMessage="Minimum investment"
                />
            ),
            definition: (
                <FormattedMessage
                    id="web-components.gics.minimum-investment-value"
                    defaultMessage="<b>{dollars, number, CAD0}</b>"
                    values={{
                        dollars: minimumInvestment,
                        ...DefaultIntlFormatValues,
                    }}
                />
            ),
        },
    ];
}


export default ProductListGICsDetails;
